import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import ThemeToggle from '../UI/ThemeToggle';
import axios from 'axios';

const API_BASE = "https://api.mbsmartweb.com/api";

const Header = ({ toggleSidebar }) => {
  const { darkMode } = useTheme();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [userData, setUserData] = useState({
    userId: '',
    name: '',
    rank: ''
  });
  const [loading, setLoading] = useState(true);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Fetch user details from API
  const fetchUserDetails = async () => {
    const userId = localStorage.getItem("UserId");
    
    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/userdetails`, { userId });
      
      if (response.data) {
        setUserData({
          userId: userId,
          name: response.data.name || userId,
          rank: response.data.RankName || 'No Rank'
        });
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
      // Fallback to localStorage data
      const userName = localStorage.getItem("UserName") || userId;
      setUserData({
        userId: userId,
        name: userName,
        rank: 'No Rank'
      });
    } finally {
      setLoading(false);
    }
  };

  // Get user data from localStorage and API
  useEffect(() => {
    fetchUserDetails();
  }, []);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserMenu(false);
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("UserId");
    localStorage.removeItem("UserName");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    navigate("/login");
  };

  const notifications = [
    { id: 1, title: 'Bot Activated', message: 'Your trading bot has been activated', time: '5 min ago', read: false },
    { id: 2, title: 'Profit Received', message: 'You received $124.50 profit', time: '1 hour ago', read: false },
    { id: 3, title: 'Withdrawal Approved', message: 'Your withdrawal request has been approved', time: '2 hours ago', read: true },
  ];

  const getUnreadCount = () => {
    return notifications.filter(n => !n.read).length;
  };

  // Function to get rank badge color
  const getRankBadgeClass = (rank) => {
    if (!rank || rank === 'No Rank') return 'rank-badge beginner';
    
    const rankLower = rank.toLowerCase();
    if (rankLower.includes('bronze')) return 'rank-badge bronze';
    if (rankLower.includes('silver')) return 'rank-badge silver';
    if (rankLower.includes('gold')) return 'rank-badge gold';
    if (rankLower.includes('platinum')) return 'rank-badge platinum';
    if (rankLower.includes('diamond')) return 'rank-badge diamond';
    if (rankLower.includes('elite')) return 'rank-badge elite';
    return 'rank-badge beginner';
  };

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <i className="fa fa-bars"></i>
        </button>
        <div className="header-title">
          <h2>Dashboard</h2>
          <span className="breadcrumb">Home &gt; Dashboard</span>
        </div>
      </div>

      <div className="header-right">
      <span 
        className={`status-text ${getRankBadgeClass(userData.rank)}`}
        data-rank={userData.rank}  // For tooltip on mobile
      >
        <i className="fa fa-trophy"></i> 
        <span className="rank-text">{userData.rank}</span>
      </span>

        {/* Notifications Dropdown - Commented out but kept for future use */}
        {/* <div className="notification-wrapper">
          <button 
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <i className="fa fa-bell"></i>
            {getUnreadCount() > 0 && (
              <span className="notification-badge">{getUnreadCount()}</span>
            )}
          </button>
          {showNotifications && (
            <div className="notification-dropdown">
              <div className="notification-header">
                <h4>Notifications</h4>
                <button>Mark all as read</button>
              </div>
              <div className="notification-list">
                {notifications.map(notif => (
                  <div key={notif.id} className={`notification-item ${!notif.read ? 'unread' : ''}`}>
                    <div className="notification-icon">
                      <i className="fa fa-bell"></i>
                    </div>
                    <div className="notification-content">
                      <h5>{notif.title}</h5>
                      <p>{notif.message}</p>
                      <span>{notif.time}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div> */}

        {/* <ThemeToggle /> */}

        {/* User Menu Dropdown */}
        <div className="user-menu-wrapper" ref={dropdownRef}>
          <button 
            className="user-menu-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <img 
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(userData.name || 'User')}&background=0f3d2f&color=fff`} 
              alt="User" 
            />
            <span>Hi, {userData.userId || 'User'}</span>
            <i className={`fa fa-chevron-${showUserMenu ? 'up' : 'down'}`}></i>
          </button>
          
          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-dropdown-header">
                <div className="user-rank-info">
                  <i className="fa fa-trophy"></i>
                  <span>Current Rank: <strong>{userData.rank}</strong></span>
                </div>
              </div>
              <Link to="/profile" onClick={() => setShowUserMenu(false)}>
                <i className="fa fa-user"></i> Profile
              </Link>
              <Link to="/change-password" onClick={() => setShowUserMenu(false)}>
                <i className="fa fa-lock"></i> Change Password
              </Link>
              <Link to="/support" onClick={() => setShowUserMenu(false)}>
                <i className="fa fa-headset"></i> Support
              </Link>
              <hr />
              <button onClick={handleLogout} className="logout-btn">
                <i className="fa fa-sign-out"></i> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;